import { useState } from 'react';
import RateDialog from './RateDialog';
import './RateButton.css';

/**
 * Вход в условия бессрочного стейкинга.
 *
 * Стоит в строке переключателя вида, рядом с «Бессрочным»: условия относятся
 * именно к нему, и искать их логично там же, где его выбирают. Отдельным
 * разделом на странице они были раньше и забирали внимания наравне с формой
 * отправки, хотя меняют их штучно, — но и прятать их в неприметную серую
 * строчку не стоило: админ должен находить их взглядом, а не по памяти.
 *
 * Открытое состояние живёт здесь, а не в `App`: кроме этой кнопки, окно
 * открывать некому.
 */
const RateButton = ({ refreshKey, onRateChanged }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="rate_button"
        onClick={() => setOpen(true)}
      >
        <span aria-hidden="true">⚙</span> Условия бессрочного стейкинга
      </button>

      {/* Окно смонтировано только пока открыто: каждое открытие читает
          условия заново, и «было» в подтверждении не бывает вчерашним. */}
      {open && (
        <RateDialog
          refreshKey={refreshKey}
          onClose={() => setOpen(false)}
          onRateChanged={onRateChanged}
        />
      )}
    </>
  );
};

export default RateButton;
